var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountain06Sky(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 3534.7,
    height: 5102.84,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3534.7 5102.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".i{fill:url(#e);}.j{fill:url(#d);}.k{fill:url(#g);}.l{fill:url(#f);}.m{fill:url(#h);}.n{fill:url(#c);}.o{fill:#fefefe;}.p{fill:#98e6fe;}.q{fill:#bcecfe;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -1255.4,
    y1: 32,
    x2: -1191.51,
    y2: 238.47,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cef6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 1700.57,
    y1: -297.42,
    x2: 1831.57,
    y2: 72.62,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cef6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 5534.84,
    y1: -1267.99,
    x2: 5264.83,
    y2: -372.26,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cef6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -4267.16,
    y1: -571.5,
    x2: -3952.71,
    y2: 205.4,
    gradientTransform: "translate(1623.98 1867.96) scale(.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cef6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 1105.34,
    y1: -3834.02,
    x2: 1476.27,
    y2: -2786.24,
    gradientTransform: "translate(1364.06 1861.65) rotate(177.56) scale(.23 -.3)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 2867.72,
    y1: -2753.62,
    x2: 3034.17,
    y2: -2215.77,
    gradientTransform: "translate(3684.74 1737.65) rotate(174.65) scale(.28 -.3)",
    xlinkHref: "#c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "30.99 0 3530.99 0 3530.99 5089.48 30.99 5089.48 30.99 0",
    style: {
      fill: "#bcecfe"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "30.99 2336.34 306.99 2115.64 482.49 2291.14 657.89 2150.74 833.49 2291.14 1040.09 2177.14 1786.59 2578.14 1500.29 3075.64 30.99 3075.64 30.99 2336.34",
    style: {
      fill: "#98e6fe"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3530.99 2160.74 3402.79 2080.54 3178.39 2256.04 2953.99 2115.64 2729.49 2256.04 2465.19 2142.04 1760.99 2580.74 1456.99 3044.74 3530.99 3040.54 3530.99 2160.74",
    style: {
      fill: "#98e6fe"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1204.49,1944.44s26.7,2.4,87.5-4.7c60.8-7.2,121.9,4.1,133.9-32.3,12-36.4-74.2-31.4-104.3-45.5-30.2-14-62.7-29-93-20.3-30.3,8.7-26,35.2-58.6,39-32.7,3.7-17.9,16.2-43.5,22.5-25.7,6.3-52.1,43.3-9,42.5,43-.8,87-1.2,87-1.2Z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.59,1945.34c-1-2.1-1.2-4.4-.3-6.8,4.6-13.6,22.8,1.7,59.2-6.4,36.4-8.2,56.3-34.6,100.2-36.8,43.9-2.1,31.7,20.7,70.6,16.8,32.5-3.3,74.1-.1,67.1,15.1-25.3,11.8-70.6,7.1-115.5,12.4-60.8,7.1-87.5,4.7-87.5,4.7,0,0-44,.5-87,1.2-2.5,.1-4.8,0-6.8-.2Z",
    style: {
      fill: "url(#c)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2363.39,1735.74s-24.2-42.4-135.7-43.1c-111.5-.6-141.7,64.6-205.2,74.4-63.4,9.8-26.7,20.1-81.8,30.1-55.1,10-96.3,40.9-74,75.9,22.4,35,65.5,24.8,145.5,34.6,80,9.8,59.2-9.3,204.4-12.6,145.3-3.3,274.8-34.6,268.3-89.6-6.3-55.2-62.7-65.9-121.5-69.7Z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1864.29,1868.74c10.7-9.8,29.9-17.7,63.4-9.9,63.9,14.8,103.6-2.6,131.1-26.1,27.6-23.4,53.2-19,91.1-1.7,37.7,17.2,90.9-2.2,117,.3,26,2.5,84.6,1.5,132.1-22,36.2-17.9,88.4,4.2,62.5,36.4-43.3,29.9-139.8,46.8-244.6,49.2-145.2,3.3-124.4,22.4-204.4,12.6-80-9.8-123.2,.4-145.5-34.6-1.2-1.4-2-2.8-2.7-4.2Z",
    style: {
      fill: "url(#d)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3530.99,1792.44c-5,.3-10,.8-15.3,1.6-68.6,9.4-61.1-33-116.4-16.5-55.3,16.5-85-3.2-141,14.2-55.9,17.4-41.5-8-115.2,1.7-73.5,9.6-269.1,39.8-278.1-57.9-8.9-97.7,104.6-101.5,175.9-122.7,71.3-21.2,80.9-94,160.1-97.5,21.5-1,45.9-9.8,72.4-20.6h257.6v297.7Z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3530.99,1792.44c-5,.3-10,.8-15.3,1.6-68.6,9.4-61.1-33-116.4-16.5-55.3,16.5-85-3.2-141,14.2-55.9,17.4-41.5-8-115.2,1.7-53.8,7.1-173,25.1-236.5-4-8.4-13.8,3.9-29.6,18.9-32,26.5-4.3,49,12.5,61.1-17.6,12.2-30.1,55.8-32.3,80.7-15.8,24.9,16.5,68.6,10,151.9-36.4,83.4-46.3,105.8,6,139.8-36.6,34-42.4,91.9-76.9,160.1-55,4.3,1.4,8.3,3,12,4.7v191.7h-.1Z",
    style: {
      fill: "url(#e)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M189.29,1928.14s295.8-53.4,358.4-51.2c62.5,2.1,88.5,1.5,121.9-10.7,33.4-12.3,61.8,1.1,98.5-12.3,36.6-13.3,90.2-6.6,100.5-31.1,10.4-24.4-42.3-40.8-69.9-37.5-27.6,3.3-29.6-35.3-91.2-40.2-61.5-4.9-81.6-60.9-133.8-53.7-52.1,7.1-109.1-10.7-159.4,28.3,0,0-28-12.7-54.4-5.1,0,0-8.7-.9-44.1-37.9-35.5-36.9-96.7-58.2-169.6-5.7-56.4,40.5-95.1,35-115.2,70.6v213.3c76-12.6,158.3-26.8,158.3-26.8Z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.29,1928.14s295.8-53.4,358.4-51.2c62.5,2.1,88.5,1.5,121.9-10.7,33.4-12.3,61.8,1.1,98.5-12.3,4-1.5,8.2-2.6,12.5-3.7,.6-2.5,1-5.1,1-7.9,.7-43.3-59.8-32.3-98.4-19.9-38.6,12.4-72.2-29.3-147-25.5-74.9,3.9-101.2,29.1-156.8,4.4-55.7-24.7-127.8-40.7-166.4,3.6s-35.4,54.7-75.3,49c-39.8-5.9-61.5,15.4-66.7,29.8-4.1,11.1-16.3,22.8-40,19.9v51.2c76-12.5,158.3-26.7,158.3-26.7Z",
    style: {
      fill: "url(#f)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M570.75,717.11s49.07-84.99,291.34-96.66c242.28-11.48,313.32,112.98,452.14,126.24,138.6,13.27,59.7,36.76,180.28,51.19,120.58,14.42,212.69,70.92,167.13,141.29-45.78,70.38-140.29,54.46-313.35,80.98-173.05,26.52-129.43-12.68-445.27-5.7-316.06,6.99-600.1-42.13-590.54-150.07,9.11-108.32,130.8-134.41,258.27-147.26Z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1666.5,930.55c-24.07-18.14-66.45-31.78-138.61-13.46-137.65,34.79-225.37,4.5-287.09-38.82-61.93-43.12-117.2-32.16-198.13,5.1-80.51,37.05-197.74,4.11-254.25,11.4-56.3,7.28-183.74,10.75-288.92-30.73-80.16-31.59-191.77,16.37-132.81,76.82,96.59,54.35,307.72,78.42,535.68,73.41,315.84-6.98,272.22,32.22,445.27,5.7,173.05-26.52,267.79-10.61,313.35-80.98,2.49-2.84,4.11-5.65,5.52-8.45Z",
    style: {
      fill: "url(#g)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2900.51,1153.16s-62.95,13.57-210.02,4.62c-147.1-9.27-289.42,40.21-328.84-72.58-39.42-112.8,167.59-116.17,235.17-167.62,67.85-51.15,140.88-105.99,215.71-85.16,74.83,20.84,72.44,105.87,151.3,110.64,79.06,4.44,47.49,47.4,110.4,61.67,63.15,14.25,137.08,125.74,34.08,132.82-102.76,7.06-207.79,15.61-207.79,15.61Z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3124.65,1135.06c1.76-6.89,1.55-14.23-1.3-21.64-15.01-42.12-53.86,10.48-143.05-7.09-89.22-17.89-144.51-97.2-249.83-94.38-105.29,3.14-69.43,72.74-163.34,69.05-78.47-3.22-176.7,16.22-155.5,62.88,63.83,31.79,170.44,6.77,279.06,13.56,147.07,8.95,210.02-4.62,210.02-4.62,0,0,105.06-8.23,207.79-15.61,5.99-.24,11.44-1.07,16.15-2.15Z",
    style: {
      fill: "url(#h)"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain06Sky);
export default __webpack_public_path__ + "static/media/mountain-06-sky.409db762409cf82af8a09d7ed8266e9a.svg";
export { ForwardRef as ReactComponent };